import { createAction, createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const biTasksBySiteAndDateRequest = createRequest(constants.biTasksBySiteAndDate);
export const biTasksBySiteAndDateSuccess = createSuccess(constants.biTasksBySiteAndDate);
export const biTasksBySiteAndDateFailure = createFailure(constants.biTasksBySiteAndDate);

export const requestBITasksBySiteAndDate = biTasksBySiteAndDateRequest;

export const biTasksByDateRequest = createRequest(constants.biTasksByDate);
export const biTasksByDateSuccess = createSuccess(constants.biTasksByDate);
export const biTasksByDateFailure = createFailure(constants.biTasksByDate);

export const requestBITasksByDate = biTasksByDateRequest;

export const biTasksBySiteRequest = createRequest(constants.biTasksBySite);
export const biTasksBySiteSuccess = createSuccess(constants.biTasksBySite);
export const biTasksBySiteFailure = createFailure(constants.biTasksBySite);

export const requestBITasksBySite = biTasksBySiteRequest;

export const biTasksScheduleStatisticsRequest = createRequest(constants.biTasksScheduleStatistics);
export const biTasksScheduleStatisticsSuccess = createSuccess(constants.biTasksScheduleStatistics);
export const biTasksScheduleStatisticsFailure = createFailure(constants.biTasksScheduleStatistics);

export const requestBITasksScheduleStatistics = biTasksScheduleStatisticsRequest;

export const biTasksByEmployeeRequest = createRequest(constants.biTasksByEmployee);
export const biTasksByEmployeeSuccess = createSuccess(constants.biTasksByEmployee);
export const biTasksByEmployeeFailure = createFailure(constants.biTasksByEmployee);

export const requestBITasksByEmployee = biTasksByEmployeeRequest;

export const biTaskLogRequest = createRequest(constants.biTaskLog);
export const biTaskLogSuccess = createSuccess(constants.biTaskLog);
export const biTaskLogFailure = createFailure(constants.biTaskLog);

export const requestBITaskLog = biTaskLogRequest;

export const setLoadingState = createAction(constants.setLoadingState);
